import { cloneElement, createElement, type ReactElement, type ReactNode } from 'react'

import { cn } from '@/legacy-src/lib/utils'

type SlotElementProps<T extends keyof JSX.IntrinsicElements> = {
  element: T
  asChild?: false
  children: ReactNode
  className?: string
} & JSX.IntrinsicElements[T]

type SlotAsChildProps = {
  asChild: true
  element?: undefined
  children: ReactElement<{
    className?: string
  }>
  className?: string
}

export type SlotProps<T extends keyof JSX.IntrinsicElements> = SlotElementProps<T> | SlotAsChildProps

export const Slot = <T extends keyof JSX.IntrinsicElements>(props: SlotProps<T>) => {
  if ('element' in props) {
    // The type is too complex for TypeScript to infer here, so we assert it manually
    const { element, children, className, ...rest } = props as SlotElementProps<T>
    return createElement(
      element,
      {
        className,
        ...rest,
      },
      children,
    )
  }

  const { asChild: _, element: __, children, className } = props
  return cloneElement(children, {
    className: cn(children.props.className, className),
  })
}
